import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import HomePage from './pages/HomePage';
import RecommendationsPage from './pages/RecommendationsPage';
import ShelfPage from './pages/ShelfPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import SubscriptionCancelPage from './pages/SubscriptionCancelPage';
import Footer from './components/Footer';
import { AuthProvider } from './components/Auth/AuthContext';
import { SubscriptionProvider } from './components/Auth/SubscriptionContext';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import { API_BASE_URL } from './config/api';

// Page tracking component
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Send pageview event to Google Analytics
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
}

// App content component that can use useLocation
function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <div className="min-h-screen flex flex-col">
      <div className="relative z-0 flex flex-col flex-grow">
        <PageTracker />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/recommendations" element={<RecommendationsPage />} />
            <Route path="/shelf" element={<ShelfPage />} />
            <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
            <Route path="/subscription/cancel" element={<SubscriptionCancelPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          </Routes>
        </main>
        {!isAdminPage && <Footer />}
      </div>
    </div>
  );
}

function App() {
  // Track site visit once per session
  useEffect(() => {
    if (!sessionStorage.getItem('siteVisitTracked')) {
      fetch(`${API_BASE_URL}/api/analytics/visit`, { method: 'POST' });
      sessionStorage.setItem('siteVisitTracked', '1');
    }
  }, []);

  return (
    <AuthProvider>
      <SubscriptionProvider>
        <Router>
          <AppContent />
        </Router>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;
